import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { NotifyService } from '@src/app/shared/services/notiflix/notify.service';
import { iApiResponse } from '@src/app/core/interfaces/iApiResponse';

@Injectable({
  providedIn: 'root'
})
export class MenuDataApi {

  private http = inject(HttpClient);
  private readonly baseUrl = environment.urlApi + '/v2/core';

  countMenuData(branch_uuid:string): Observable<iApiResponse> {
    return this.http.get<iApiResponse>(`${this.baseUrl}/count-menu-data/${branch_uuid}`);
  }


}
